import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Purchase } from "../../models/purchase.model";
import Shop from "../../models/shop.model";

import { PurchaseService } from "../../services/purchase.service";

@Component({
  selector: "ngx-dialog-view-purchase",
  templateUrl: "dialog-view-purchase.component.html",
  styleUrls: ["dialog-view-purchase.component.scss"],
})
export class DialogViewPurchaseComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() shop: Shop = new Shop();

  @Input() purchase?: Purchase;
  @Input() purchaseId?: string;
  loading: boolean = false;

  constructor(
    protected ref: NbDialogRef<DialogViewPurchaseComponent>,
    private purchaseService: PurchaseService
  ) {}

  ngOnInit() {
    console.log("ngOnInit/purchase:", this.purchaseId);
    if (!this.purchase && this.purchaseId) {
      //load purchase
      this.loading = true;

      this.purchaseService
        .getPurchase(this.shopId, this.purchaseId)
        .then((doc) => {
          if (doc.exists) {
            this.purchase = new Purchase();
            this.purchase = doc.data();
            this.purchase.id = this.purchaseId;
            this.purchase.createdOn = convertTimestamp(doc.data().createdOn);
            this.purchase.issueDate = convertTimestamp(doc.data().issueDate);
          }
          console.log("getPurchase:", this.purchase);

          this.loading = false;
        })
        .catch((err) => {
          console.log("getPurchase:null");

          this.loading = false;
        });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDelete(id) {
    console.log("DialogViewPurchaseComponent/onDelete:", id);
    this.ref.close(id);
  }

  close() {
    this.ref.close();
  }
}
